export default __webpack_public_path__ + "static/media/add_servicos_gestor.3f85dd5a.png";